import FinancialInfoComponent from './FinancialInfoContainer';

export default FinancialInfoComponent